import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoCondicoesPagamento } from 'pages/compra/configuracao-pedido/types';

export function useQueryCondicoesPagamento() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<ConfigPedidoCondicoesPagamento>({
        queryKey: ['config-pedido-condicoes-pagamento', id],
        queryFn: () =>
            requestListagem({
                url: `/gestao/configpedidocondicaopagamentowrapper/configpedido/${id}`,
            }).then((res) => res.data),
    });
}
